import $ from "jquery";
import {rates} from './instant'
import {checkSymbols} from "./helpers";
import {
    checkTxStatus,
    checkMaxAmountUsd,
    calcLoanLimitValue,
    CALC_USD_TYPE,
    CALC_BTC_TYPE,
    NON_VISIBLE,
    INFO_BACKGR,
    INFO_BACKGR_CONTENT
} from "./refillAdditional";

let exchangeRates = [],
    needGetRate = false,
    needCheckProcessed = false;

const REFILL_USD = $('#refill-usd'),
      REFILL_BTC = $('#refill-btc'),
      LOAN_LIMIT_VALUE = $('#loan-limit-value'),
      BTC_IN_ADDR = $('#refill-btc-wallet'),
      ADD_FUNDS_MODAL = $('#refill');

const calcRefillValues = (type = CALC_USD_TYPE, USD_INPUT_FIELD, BTC_INPUT_FIELD) => {
    let btcExchangeRate = exchangeRates['BTC']['rate'],
        btcValue,
        usdAmount,
        usdValue = USD_INPUT_FIELD.val();
    if (btcExchangeRate) {
        if (type === CALC_BTC_TYPE) {
            const btcAmount = BTC_INPUT_FIELD.val();
            btcValue = btcAmount
            usdAmount = Math.round(btcAmount / btcExchangeRate * 100) / 100;
            USD_INPUT_FIELD.val(usdAmount);
            usdValue = usdAmount;
        }
        if (type === CALC_USD_TYPE) {
            btcValue = (usdValue * btcExchangeRate).toFixed(8);
            BTC_INPUT_FIELD.val(btcValue);
        }
    }

    return {
        'usd': usdValue,
        'btc': btcValue,
    }
}

const fillRefillData = (type = CALC_USD_TYPE) => {
    const calcData = calcRefillValues(type, REFILL_USD, REFILL_BTC)
    refillSetAdditional(calcData['usd']);
}

const processingRefill = () => {
    rate();
    needCheckProcessed = true;
}

const refillModalShow = () => {
    ADD_FUNDS_MODAL.on('show.bs.modal', function (e) {
        needGetRate = true
        calcLoanLimitValue(REFILL_USD.val());
        processingRefill()
    })
}

const refillSetAdditional = (usdAmount) => {
    const calcLoanLimit = calcLoanLimitValue(usdAmount)
    LOAN_LIMIT_VALUE.text(calcLoanLimit);
}

const refillModalHidden = () => {
    ADD_FUNDS_MODAL.on('hidden.bs.modal', function (e) {
        $('#refillQrCodeBlock').addClass(NON_VISIBLE);
        needGetRate = false;
    })
}

const rate = () => {
    exchangeRates = rates;
    fillRefillData();
}

const updateRefillData = (type) => {
    checkSymbols('refill-btc');
    checkSymbols('refill-usd');
    checkMaxAmountUsd('refill-usd');
    fillRefillData(type);
}

const txCheckStatus = () => {
    const waitPaymentLabel = $('#refill-wait-payment');
    const confirmationBlock = $('#refill-confirmation-block');
    const txOnline = $('#refill-transaction-online')
    const txConfirmations = $('#refill-confirmation-count')
    const btcInAddrValue = BTC_IN_ADDR.val();
    const modalSelector = 'refill';
    checkTxStatus(waitPaymentLabel, confirmationBlock, txOnline, txConfirmations, btcInAddrValue, modalSelector)
}

const activeFieldStyle = () => {
    REFILL_USD.focusin(function () {
        $('#refill-prepend-usd').addClass(INFO_BACKGR);
        $('#refill-prepend-usd-text').addClass(INFO_BACKGR_CONTENT);
    });
    REFILL_USD.focusout(function () {
        $('#refill-prepend-usd').removeClass(INFO_BACKGR);
        $('#refill-prepend-usd-text').removeClass(INFO_BACKGR_CONTENT);
    });
    REFILL_BTC.focusin(function () {
        $('#refill-prepend-btc').addClass(INFO_BACKGR);
        $('#refill-prepend-btc-text').addClass(INFO_BACKGR_CONTENT);
    });
    REFILL_BTC.focusout(function () {
        $('#refill-prepend-btc').removeClass(INFO_BACKGR);
        $('#refill-prepend-btc-text').removeClass(INFO_BACKGR_CONTENT);
    });
}

$(document).ready(() => {
    activeFieldStyle();
    refillModalShow();
    refillModalHidden();
    setInterval(function () {
        if (needGetRate) {
            rate();
        }
    }, 60 * 1000);
    setInterval(function () {
        if (needCheckProcessed && BTC_IN_ADDR) {
            txCheckStatus();
        }
    }, 60 * 1000);
});

window.updateRefillData = updateRefillData;
